export default __webpack_public_path__ + "static/logo.0953c1654091b6c359074102c8dbf720.png";